"use client";

import Heading from "~/componentsDS/Typography/Heading";
import Reveal from "~/componentsDS/Reveal";
import ElementorContainer from "~/componentsDS/ElementorLoyout/ElementorContainer";
import HormoneSupportComparison from "../../components/HormoneSupportComparison";
import { hrtHormoneSupportContent } from "../../data/hormone-support-content";
import { QuizCTA } from "~/components/features/quiz";
import { QUIZ_ROUTES } from "~/constants/quizRoutes";
import TextWithRegisteredMark from "~/componentsDS/TextWithRegisteredMark";
import useLpCtaText from "~/hooks/useLpCtaText";
import { GTM_EVENT_NAMES } from "~/constants/gtmEvents";

const CTA_TITLE = "see if Oestra® Is a better fit"

const HormoneSupportSection = () => {

    const ctaTitle = useLpCtaText(CTA_TITLE);

    return (
        <section className="overflow-hidden">
            <ElementorContainer innerClassName="flex flex-col">
                <div className="px-0 md:px-8">
                    <Reveal>
                        <Heading as="h2" size="sm" sizes={{ md: "md" }} className="text-center text-primary500 mb-3">
                            Stop managing your
                            {" "}<Heading as="i" font="featureDisplay" weight="400" className="text-[28px] md:text-[36px]">hormones</Heading>{" "}
                            like a to-do list
                        </Heading>
                    </Reveal>
                </div>

                <HormoneSupportComparison content={hrtHormoneSupportContent} />

                <div className="mt-4 mx-auto max-md:w-full">
                    <QuizCTA
                        className="px-8 w-full md:w-fit"
                        href={QUIZ_ROUTES.HORMONE_IMBALANCE}
                        eventData={{
                            event_name: GTM_EVENT_NAMES.LP_INTERACTION,
                            widget: "lp_patchwork_replacement",
                            meta_data: {
                                click_text: CTA_TITLE
                            },
                        }}
                    >
                        <TextWithRegisteredMark text={ctaTitle} />
                    </QuizCTA>
                </div>
            </ElementorContainer>
        </section>
    );
};

export default HormoneSupportSection;
